import { http } from '@pendo/http';
import sortBy from 'lodash/sortBy';
import { i18n_t as $t } from '@utils/i18n';

export function fetchLayouts () {
    return http.get('/api/s/_SID_/layout').then((res) => res.data);
}

export function fetchOrganizationLayouts (orgId, subId) {
    return http.get(`/api/organization/${orgId}/resources/layout?subId=${subId}`).then((res) => res.data);
}

export function deleteLayout (id) {
    return http.delete(`/api/s/_SID_/layout/${id}`);
}

export function fetchLayoutCategories ({ items } = {}) {
    const params = items ? '?items=true' : '';

    return http.get(`/api/s/_SID_/category/layoutCategory${params}`);
}

export function sortByName (sortArray) {
    return sortBy(sortArray, (item) => item.name.toUpperCase());
}

export function createUnassignedMetaGroup (items = []) {
    return {
        name: $t('metaGroups.Custom'),
        id: '_PENDO_UNASSIGNED_META_GROUP_',
        description: 'Unassigned categories',
        length: items.length,
        type: 'metaGroup',
        items: sortByName(items),
    };
}